'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { logError } from '@/app/actions/log'
import { trackEvent } from '@/firebase'

export default function NotFound() {
  const pathname = usePathname()

  useEffect(() => {
    logError(`Could not find ${pathname}`)

    trackEvent('page-notfound', {
      page_path: window.location.pathname,
      page_title: document.title,
      page_referrer: document.referrer,
      page_host: window.location.host,
      page_hostname: window.location.hostname,
      page_protocol: window.location.protocol,
    })
  }, [pathname])

  return (
    <div className="text-center">
      <h2 className="text-2xl py-4">Not Found</h2>
      <p className="px-2">
        Could not find <span className=" underline italic">{pathname}</span>
      </p>
      <Link href="/" className="inline-block underline text-orange-600 mt-4">
        Return Home
      </Link>
    </div>
  )
}
